import Api from './Api'

const END_POINT = 'category-gasto'

export default {
    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(categoryGasto) {
        return await Api.post(`${END_POINT}`, categoryGasto)
    },
    async update(categoryGasto) {
        return await Api.patch(`${END_POINT}/${categoryGasto.id}`, categoryGasto)
    },
    async change_status(categoryGasto) {
        return await Api.patch(`${END_POINT}/${categoryGasto.id}/change-status`, categoryGasto)
    },
    async delete(categoryGasto) {
        return await Api.delete(`${END_POINT}/${categoryGasto.id}`, categoryGasto)
    }
}